<template>
  <div class="upsell-takeover" data-testid="upsell-takeover">
    <div
      class="upsell-takeover__content mx-auto flex w-full flex-col items-center gap-10 p-6 pt-12 pb-28"
    >
      <UpsellHero :title="title" :description="description" />
      <UpsellFeatures :features="features" />
      <PlanComparisonTable
        :caption="tableCaption"
        :current-plan="plans[0]"
        :plans="plans"
        :sections="sections"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useMaxUpsellContent } from '../composables/useMaxUpsellContent'

import PlanComparisonTable from './PlanComparisonTable.vue'
import UpsellFeatures from './UpsellFeatures.vue'
import UpsellHero from './UpsellHero.vue'

const { description, features, plans, sections, tableCaption, title } =
  useMaxUpsellContent()
</script>

<style lang="scss" scoped>
// Dark upsell surface from the tier-upgrades dark design: near-black base
// with a teal glow behind the hero. The custom-property overrides re-skin
// every OwnType / divider underneath without per-component dark variants.
.upsell-takeover {
  --text-color-primary: #f5f7f6;
  --text-color-secondary: rgb(255 255 255 / 80%);
  --text-color-tertiary: #6f7672;
  --divider: rgb(255 255 255 / 8%);

  position: relative;
  min-height: 100%;
  background-color: #0c0e0e;
  // Design-exported top glow (replaces the hand-built radial gradients).
  background-image: url('../assets/gradient-lines.png');
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;

  // 854px design frame + 24px side padding on each side. Deliberately no
  // position/z-index here: a stacking context would isolate the gate badge's
  // color-dodge fill from the gradient backdrop it blends against.
  &__content {
    max-width: 902px;
  }
}
</style>
